import { render } from "./Advances.vue?vue&type=template&id=f3493480&scoped=true"
import script from "./Advances.vue?vue&type=script&lang=js"
export * from "./Advances.vue?vue&type=script&lang=js"

import "./Advances.vue?vue&type=style&index=0&id=f3493480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3493480"]])

export default __exports__